/* import styled, { keyframes } from "styled-components";
import { shade } from "polished";

export const Container = styled.div`
  height: 90vh;
  display: flex;
  align-items: stretch;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  place-content: center;
  width: 100%;
`;

const appearFromLeft = keyframes`
  from{
    opacity: 0;
    transform: translateX(-50px);
  }
  to{
    opacity: 1;
    transform: translateX(0)
  }`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: ${appearFromLeft} 1s;
  form {
    margin: 80px 0;
    width: 340px;
    text-align: center;
    h1 {
      margin-bottom: 24px;
    }
    a {
      color: #f4ede8;
      display: block;
      margin-top: 24px;
      text-decoration: none;
      transition: color 0.2s;
      &:hover {
        color: ${shade(0.2, "#f4ede8")};
      }
    }
  }
  > a {
    color: #ff9000;
    display: block;
    margin-top: 24px;
    text-decoration: none;
    transition: color 0.2s;
    display: flex;
    align-items: center;
    svg {
      margin-right: 16px;
    }
    &:hover {
      color: ${shade(0.2, "#ff9000")};
    }
  }
`;

export const Rodape = styled.div`
  position: absolute;
  width: 100%;
  height: 20%;
  bottom: 0;
  left: 0;
  font-size: 10pt;
  z-index: 10;
  border: 1px solid #f00;
`;
 */

import styled, { keyframes } from "styled-components";
import { shade } from "polished";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .buttonCancelar {
    background: none;
    color: #424242;
    border: 2px solid #cecece;
  }
`;

export const Content = styled.div`
  display: flex;

  flex-direction: column;
  align-items: center;
  place-content: center;

  width: 350px;
  height: 550px;
  margin: 5% 0px;
`;

const appearFromLeft = keyframes`
  from{
    opacity: 0;
    transform: translateX(-50px);


  }
  to{
    opacity: 1;
    transform: translateX(0)
  }`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: ${appearFromLeft} 1s;
  margin: 7% 0px;
  form {
    margin: 10px 10px;
    width: 100%;
    text-align: center;
    h1 {
      /* margin-bottom: 10px; */
      text-align: left;
      color: #3d3d3d;
    }
    a {
      color: #f4ede8;
      display: block;
      margin-top: 24px;
      text-decoration: none;
      transition: color 0.2s;
      &:hover {
        color: ${shade(0.2, "#f4ede8")};
      }
    }
  }

  .form img {
    margin: 20px 0px;
  }

  .input {
  }

  .row {
    text-align: left;
    display: flex;
    margin-top: 20px;
  }

  .row h1 {
    padding-left: 10px;
    color: #008241;
    font-weight: 500;
    font-size: 3rem;
    margin-bottom: 0;
  }

  .row h3 {
    padding-left: 10px;
    color: #616161;
    line-height: 0%;
  }
  > a {
    color: #ff9000;
    display: block;
    margin-top: 24px;
    text-decoration: none;
    transition: color 0.2s;
    display: flex;
    align-items: center;
    svg {
      margin-right: 16px;
    }
    &:hover {
      color: ${shade(0.2, "#ff9000")};
    }
  }

  .containerImg {
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .containerImg img {
    width: 35%;
  }

  @media (max-width: 600px) {
    .containerImg img {
      width: 30%;
    }
    .from {
      padding: 15% 8%;
    }

    .row {
      display: block;
    }

    .row h1 {
      padding-left: 10px;
      color: #008241;
      font-weight: 500;
      font-size: 2rem;
    }
  }
`;

export const Rodape = styled.div`
  position: absolute;
  width: 100%;
  height: 20%;
  bottom: 0;
  left: 0;
  font-size: 10pt;
  z-index: 10;
  border: 1px solid #f00;
`;
